import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const SingleLineSmartLinkEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(() =>
		import(/* webpackChunkName: "async-issue-field-single-line-smart-link" */ './index').then(
			(module) => module.SingleLineSmartLink,
		),
	),
	getPreloadProps: () => ({}),
});
